<template>
	<b-modal ref="mdlWidgetEditorHeader" dialog-class="sa-modal-full-height" title="Modifica Widget" @ok="handleSave" ok-title="Salva" cancel-title="Annulla" size="xl" @show="loadQueryList" @shown="onWidgetShown" scrollable>
		<div class="app-layout">
			<aside class="sidebar">
				<b-row>
					<b-col cols="12">
						<b-form-group label="Titolo Widget:">
							<b-form-input v-model="mxChartConfig.title" type="text" />
						</b-form-group>
					</b-col>
				</b-row>
				<hr />
				<h6 class="text-success small mb-3">🎨 Stile e Colori</h6>
				<b-row>
					<b-col cols="12">
						<b-form-group label="Colore Icona:">
							<b-form-select v-model="mxChartConfig.colorIconClass" text-field="color" value-field="colorClass" :options="colorIconClassOptions" />
						</b-form-group>
					</b-col>
					<b-col cols="12">
						<b-form-group label="Icona Widget:">
							<b-dropdown variant="outline-secondary" block menu-class="w-100">
								<template #button-content>
									<i :class="mxChartConfig.icon || 'fas fa-icons'" class="mr-2"></i>
									{{ mxChartConfig.icon ? mxChartConfig.icon : "Seleziona Icona" }}
								</template>

								<b-dropdown-form>
									<b-form-input v-model="iconSearch" size="sm" placeholder="Cerca icona..."></b-form-input>
								</b-dropdown-form>
								<b-dropdown-divider></b-dropdown-divider>

								<div style="max-height: 200px; overflow-y: auto">
									<b-dropdown-item v-for="icon in filteredIcons" :key="icon" @click="mxChartConfig.icon = icon">
										<i :class="icon" class="mr-3" style="width: 20px; text-align: center"></i>
										<small>{{ icon }}</small>
									</b-dropdown-item>
								</div>
							</b-dropdown>
						</b-form-group>
					</b-col>
				</b-row>
				<hr />
				<h6 class="text-primary small mb-3">Mappatura Campi & Aggregazione</h6>
				<b-row>
					<b-col cols="12">
						<b-form-group label="Sorgente Dati (Query):">
							<b-input-group>
								<b-form-select v-model="mxChartConfig.idQuery" value-field="id" text-field="title" :options="queryOptions">
									<template #first>
										<b-form-select-option :value="null" disabled>-- Seleziona una query --</b-form-select-option>
									</template>
								</b-form-select>

								<b-input-group-append>
									<b-button variant="primary" :disabled="!mxChartConfig.idQuery || isExecuting" @click="queryLoadData">
										<b-spinner v-if="isExecuting" small></b-spinner>
										<span v-else>⚡ Esegui</span>
									</b-button>
								</b-input-group-append>
							</b-input-group>
							<small class="text-muted" v-if="queryOptions.length > 0">
								✅ Query eseguita: trovati <strong>{{ fieldOptions.length }}</strong> campi.
							</small>
						</b-form-group>
					</b-col>
				</b-row>
				<div class="sa-data-analysis-section-header text-primary">1. Dimensioni</div>
				<b-row>
					<b-col cols="6">
						<b-form-group label="Campo Valore Principale:" label-class="small">
							<b-form-select v-model="mxChartConfig.principalField" :options="fieldOptions" @change="onFieldChange()"></b-form-select>
						</b-form-group>
					</b-col>
					<b-col cols="6">
						<b-form-group label="Aggregazione:" label-class="small">
							<b-form-select v-model="mxChartConfig.principalAgg" :options="getAvailableAgg(mxChartConfig.principalField)" @change="onAggFieldChange()"></b-form-select>
						</b-form-group>
					</b-col>
					<b-col cols="12">
						<b-form-group label="Tipologia di Dato">
							<b-form-select v-model="mxChartConfig.tipologyData" :options="tipologyDataOptions" />
						</b-form-group>
					</b-col>
					<b-col cols="6">
						<b-form-group label="Campo Valore Principale:" label-class="small">
							<b-form-select v-model="mxChartConfig.totalField" :options="fieldOptions" @change="onFieldChange()"></b-form-select>
						</b-form-group>
					</b-col>
					<b-col cols="6">
						<b-form-group label="Aggregazione:" label-class="small">
							<b-form-select v-model="mxChartConfig.totalFieldAgg" :options="getAvailableAgg(mxChartConfig.totalField)" @change="onAggFieldChange()"></b-form-select>
						</b-form-group>
					</b-col>
					<b-col cols="6">
						<b-form-group label="Valore Secondario">
							<b-form-select v-model="mxChartConfig.secondaryValueType" :options="secondaryValueTypeOptions" />
						</b-form-group>
					</b-col>
					<b-col v-if="mxChartConfig.secondaryValueType === 'T'" cols="6">
						<b-form-group label="Valore Riferimento:">
							<b-form-input v-model="mxChartConfig.referenceValue" type="number" />
						</b-form-group>
					</b-col>
					<b-col v-if="mxChartConfig.secondaryValueType !== 'T'" cols="6">
						<b-form-group label="Label Secondaria:">
							<b-form-input v-model="mxChartConfig.secondaryLabel" type="text" />
						</b-form-group>
					</b-col>
				</b-row>

				<hr />
				<h6 class="text-muted small mb-3">Layout Responsivo</h6>
				<b-row>
					<b-col v-for="size in ['xs', 'sm', 'md', 'lg', 'xl']" :key="size">
						<b-form-group :label="size.toUpperCase()">
							<b-form-select v-model="mxChartConfig[size]" :options="gridOptions" />
						</b-form-group>
					</b-col>
				</b-row>
			</aside>

			<main class="main-container">
				<section style="height: 100%" class="content">
					<b-tabs id="tabsDashboardView" ref="tabsDashboardView" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill>
						<b-tab title="">
							<template #title> <i class="fas fa-chart-bar mr-2"></i>Anteprima Grafico </template>
							<div class="sa-widget-editor-header-body">
								<b-overlay :show="showOverlay" rounded="sm" style="min-width: 300px">
									<b-card class="sa-card sa-header-nowrap sa-info-card-dashboard" header-tag="header" footer-tag="footer" title="">
										<b-card-body>
											<div class="sa-widget-body-data">
												<div v-if="mxChartConfig.colorIconClass" class="sa-widget-body-data-left">
													<div :class="mxChartConfig.colorIconClass" class="sa-widget-header-icon-box">
														<i :class="mxChartConfig.icon" class="mr-0"></i>
													</div>
												</div>

												<div class="sa-widget-body-data-content">
													<span class="sa-widget-body-data-title">{{ mxChartConfig.title }}</span>
													<h3>{{ mxChartConfig.aggregationResult }} {{ mxChartConfig.tipologyData }} {{ valoreProporzionale }}</h3>
													<span class="sa-widget-body-data-subtitle">
														<small :class="secondaryColor">
															<span v-if="secondaryIconVisible" :key="iconKey">
																<i :class="secondaryIcon"></i>
															</span>
															{{ secondaryValue }} {{ mxChartConfig.secondaryLabel }}</small
														>
													</span>
												</div>
											</div>
										</b-card-body>
									</b-card>
								</b-overlay>
							</div>
						</b-tab>
						<b-tab title="Dati Query">
							<template #title> <i class="fas fa-table mr-2"></i>Dati Grezzi (Query) </template>
							<div class="b-table-sticky-header">
								<b-table responsive striped hover small :items="this.testData" class="mt-3">
									<template #table-caption>Mostrando i primi 10 record del risultato query.</template>
								</b-table>
							</div>
						</b-tab>
						<b-tab title="Kekko è Strunz">
							<template #title> <i class="fas fa-calculator mr-2"></i>Dati Aggregati </template>
						</b-tab>
					</b-tabs>
				</section>
			</main>
		</div>
	</b-modal>
</template>

<script>
import DataAnalysisHeaderMixin from "../mixins/DataAnalysisHeaderMixin";
import axios from "axios";
export default {
	name: "WidgetEditor",
	mixins: [DataAnalysisHeaderMixin],
	props: {
		config: {
			type: Object,
			required: false,
		},
	},
	components: {},
	created() {
		this.setMxChartConfig(this.config);
	},
	data() {
		return {
			test: { title: "Prova", value: 23456 },
			iconKey: 0,
			pathResourceQueryList: "/dataanalysisquery",
			showOverlay: false,
			graphicOptions: [],
			paletteOptions: [],
			selectedPaletteColors: [],
			queryOptions: [],
			isExecuting: false,
			aggregationResult: 0,
			iconSearch: "",
			colorIconClass: "sa-widget-header-icon-box-red",
			// Set di icone consigliate per una dashboard RSA
			availableIcons: [
				"fas fa-chart-bar",
				"fas fa-chart-pie",
				"fas fa-chart-line",
				"fas fa-user-md",
				"fas fa-hospital-user",
				"fas fa-bed",
				"fas fa-pills",
				"fas fa-stethoscope",
				"fas fa-ambulance",
				"fas fa-notes-medical",
				"fas fa-heartbeat",
				"fas fa-users",
				"fas fa-exclamation-triangle",
				"fas fa-calendar-check",
			],
			colorIconClassOptions: [
				{ color: "Blu", colorClass: "sa-widget-header-icon-box-blue" },
				{ color: "Gialla", colorClass: "sa-widget-header-icon-box-yellow" },
				{ color: "Grigia", colorClass: "sa-widget-header-icon-box-gray" },
				{ color: "Rossa", colorClass: "sa-widget-header-icon-box-red" },
				{ color: "Verde", colorClass: "sa-widget-header-icon-box-green" },
			],
			tipologyDataOptions: [
				{ text: "Nessuna", value: null },
				{ text: "Percentuale", value: "%" },
				{ text: "Frazionale", value: "/" },
				{ text: "Di...", value: "di" },
			],
			secondaryValueTypeOptions: [
				{ text: "Nessuna", value: null },
				{ text: "Percentuale", value: "%" },
				{ text: "Target", value: "T" },
			],
			gridOptions: Array.from({ length: 12 }, (_, i) => ({ value: i + 1, text: i + 1 })),
		};
	},

	computed: {
		title() {
			return "";
		},

		filteredIcons() {
			return this.availableIcons.filter((icon) => icon.toLowerCase().includes(this.iconSearch.toLowerCase()));
		},
		fieldOptions() {
			if (this.testData && this.testData.length > 0) {
				return Object.keys(this.testData[0]).map((key) => ({
					value: key,
					text: key,
				}));
			}
			return [];
		},
	},
	mounted() {},
	methods: {
		setChartParams(chartParams) {
			chartParams;
			//this.mxChartConfig = chartParams;
		},
		setSecondaryIcon() {
			let localIcon = "";
			if (this.mxChartConfig.secondaryValueType === "T") {
				this.secondaryIconVisible = true;
				this.mxChartConfig.secondaryLabel = "";
				localIcon = this.mxChartConfig.aggregationResult >= this.mxChartConfig.referenceValue ? "fas fa-exclamation-triangle" : "fas fa-check";
			} else {
				this.secondaryIconVisible = this.mxChartConfig.secondaryLabel ? true : false;
				localIcon = this.mxChartConfig.secondaryLabel ? "fas fa-info" : "";
			}

			if (localIcon !== this.secondaryIcon) {
				this.secondaryIcon = localIcon;
				this.iconKey++;
			}
		},
		loadQueryList() {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResourceQueryList;
			axios.get(link)
				.then((response) => {
					me.queryOptions = response.data.data.list;
					if (this.mxChartConfig.idQuery) {
						//this.testQuery();
					}
				})
				.catch((e) => {
					console.log(e);
				});
		},
		getAvailableAgg(fieldName) {
			fieldName;
			const basic = [{ value: "count", text: "Conteggio (Count)" }];
			if (this.isNumeric(fieldName)) {
				return [...basic, { value: "sum", text: "Somma (Sum)" }, { value: "avg", text: "Media (Avg)" }, { value: "min", text: "Minimo (Min)" }, { value: "max", text: "Massimo (Max)" }];
			}
			return basic;
		},
		isNumeric(fieldName) {
			fieldName;
			if (!this.testData.length || !fieldName) return false;
			const val = this.testData[0][fieldName];
			return typeof val === "number" || (!isNaN(parseFloat(val)) && isFinite(val));
		},
		onFieldChange() {
			if (!this.isNumeric(this.mxChartConfig.principalField)) this.mxChartConfig.principalAgg = "count";
		},
		onTotalFieldChange() {
			if (!this.isNumeric(this.mxChartConfig.totalField)) this.mxChartConfig.totalFieldAgg = "count";
		},
		onAggFieldChange() {
			//this.mxChartConfig.aggregationResult = this.aggregateData(this.mxChartConfig.principalField, this.mxChartConfig.principalAgg);
			//this.mxChartConfig.aggregationResult = this.aggregateData();
			this.aggregateData();
		},
		handleSave() {
			// Se svuotiamo il campo secondario, puliamo anche la granularità
			this.$emit("updateConfig", this.mxChartConfig);
		},
		addSeries() {},
		show() {
			this.$refs.mdlWidgetEditorHeader.show();
		},
		onWidgetShown() {
			this.loadWidgetData();
		},
	},
};
</script>
<style scoped>
/* 3. Adatta il tuo app-layout */
.app-layout {
	display: flex;
	flex: 1; /* Occupa tutto lo spazio disponibile nel body della modale */
	width: 100%;
	height: 100%; /* Importante per far scorrere la sidebar o il main separatamente */
}

.main-container {
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow-y: auto; /* Solo il contenuto principale scorre */
	background-color: #fff;
}

.sidebar {
	width: 320px;
	background-color: #f8f9fa;
	overflow-y: auto;
	overflow-x: hidden;
	height: 100%;
	padding: 10px;
}
.sa-data-analysis-section-header {
	font-size: 0.75rem;
	font-weight: bold;
	text-transform: uppercase;
	color: #6c757d;
	border-bottom: 1px solid #eee;
	padding-bottom: 5px;
	margin-bottom: 15px;
	margin-top: 20px;
}
.sa-data-analysis-series-item {
	background: #ffffff;
	border: 1px solid #e9ecef;
	border-left: 4px solid #007bff;
	border-radius: 8px;
	padding: 15px;
	margin-bottom: 15px;
	position: relative;
	transition: all 0.2s;
}
.sa-data-analysis-series-item:hover {
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
